<div class="content">
  <div class="icon-container">
    <app-responsive-icon [icon]="icon"></app-responsive-icon>
  </div>

  <div class="text-container">
    <h3>{{ text }}</h3>
  </div>

  <div class="button-container">
    <button [appButton]="'ghost'" (click)="handleButtonClicked($event)">
      {{ buttonText }}
    </button>
  </div>
</div>

